var DynamicCouductError = /** @class */ (function () {
    function DynamicCouductError() {
        this._horInvalidList = [];
        this._verInvalidList = [];
        this._roaInvalidList = [];
        this._verProportionInValidList = [];
        this._rotProportionInValidList = [];
        this._horProportionInValidList = [];
    }
    Object.defineProperty(DynamicCouductError.prototype, "isHorProportionInValid", {
        get: function () {
            return this._horProportionInValidList.length > 0;
        },
        set: function (val) {
            if (!val) {
                this._horProportionInValidList = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "isRotProportionInValid", {
        get: function () {
            return this._rotProportionInValidList.length > 0;
        },
        set: function (val) {
            if (!val) {
                this._rotProportionInValidList = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "isVerProportionInValid", {
        get: function () {
            return this._verProportionInValidList.length > 0;
        },
        set: function (val) {
            if (!val) {
                this._verProportionInValidList = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "horInvalidList", {
        get: function () {
            return this._horInvalidList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "verInvalidList", {
        get: function () {
            return this._verInvalidList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "rotInValidList", {
        get: function () {
            return this._roaInvalidList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "verProportionInValidList", {
        get: function () {
            return this._verProportionInValidList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "rotProportionInValidList", {
        get: function () {
            return this._rotProportionInValidList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "horProportionInValidList", {
        get: function () {
            return this._horProportionInValidList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "isVerInValid", {
        get: function () {
            return this._verInvalidList.length > 0;
        },
        set: function (val) {
            if (!val) {
                this._verInvalidList = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "isHorInValid", {
        get: function () {
            return this._horInvalidList.length > 0;
        },
        set: function (val) {
            if (!val) {
                this._horInvalidList = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCouductError.prototype, "isRotInValid", {
        get: function () {
            return this._roaInvalidList.length > 0;
        },
        set: function (val) {
            if (!val) {
                this._roaInvalidList = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    DynamicCouductError.prototype.setAllValid = function () {
        this.isHorInValid = false;
        this.isRotInValid = false;
        this.isVerInValid = false;
        this.isRotProportionInValid = false;
        this.isVerProportionInValid = false;
        this.isHorProportionInValid = false;
    };
    Object.defineProperty(DynamicCouductError.prototype, "hasAnyError", {
        get: function () {
            return this.isHorInValid || this.isRotInValid ||
                this.isVerInValid || this.isHorProportionInValid ||
                this.isRotProportionInValid || this.isVerProportionInValid;
        },
        enumerable: true,
        configurable: true
    });
    return DynamicCouductError;
}());
export { DynamicCouductError };
